import { useQuery } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'
import { UserRole } from '@/models'

export type ReservationsTransaction = {
  type: 'charge' | 'refund'
  cardLast4: string | null
  cardBrand: string | null
  initiatedBy: {
    id: string
    firstName: string
    lastName: string
    email: string
    role: UserRole
  } | null
  amount: number
  processingFee: number | null
  reason: string
  createdAt: number
}

export type ReservationTransactionsInfo = {
  totals: {
    totalCharged: number
    totalRefunded: number
    netAmount: number
  }
  transactions: ReservationsTransaction[]
}

export const RESERVATION_TRANSACTIONS_QUERY_KEY = 'reservationTransactions'

export const getReservationTransactionsQueryKey = (reservationId: string) => [
  RESERVATION_TRANSACTIONS_QUERY_KEY,
  reservationId,
]

const getReservationTransactions = async (reservationId: string) => {
  const response = await authAPI.get<ReservationTransactionsInfo>(
    `/reservation/${reservationId}/transactions`,
  )
  return response.data
}

export const useGetReservationTransactions = (reservationId: string) => {
  return useQuery({
    enabled: !!reservationId,
    queryFn: () => getReservationTransactions(reservationId),
    queryKey: getReservationTransactionsQueryKey(reservationId),
  })
}
